import { render, staticRenderFns } from "./HistoricoSenadoList.vue?vue&type=template&id=693eaed2"
import script from "./HistoricoSenadoList.vue?vue&type=script&lang=js"
export * from "./HistoricoSenadoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports